
import './ModalInvoicesHistory.css'
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import './ModalCreateEventForm.css'
import fetchData from '../../../function/fetchData';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNoteSticky, faXmark, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Spinner from 'react-bootstrap/Spinner';


import React from 'react'

const ModalInvoicesHistory = ({server, token, onShow, onHide}) => {
    const serveAddress = server + '/api2/adminInvoiceController.php';
    const [loading, setLoading] = useState(false)

    const format = (date) => {
        return moment(date).format('DD.MM.YYYY')
    }

    const [listOfInvoices, setListOfInvoices] = useState([])

    // mai n fetch
    const fetchActualData = () => {
        fetchData(serveAddress , {token: token, action: 'SHOW'})
        .then( (res) => {
            if(res.status === "OK"){
                setListOfInvoices(res.payload.invoices)
            } else {
                alert('Chyba spojení')
            }
        })
    } 
     // Stáhne data
    useEffect( ()=> {
        fetchActualData()
    }, [])


    // Delete one
    const handleDelete = ( id ) => {
        const confirmDeletion = window.confirm("Opravdu si přejete smazat tuto fakturu?");
        if (confirmDeletion) {
            fetchData(serveAddress , {token: token, action: 'DELETE', id: id})
            .then( (res) => {
                console.log(res)
                if(res.status === 'OK'){
                    fetchActualData()
                } else {
                    alert('Chyba spojení, zkuste to prosím později.')
                }
            })
        }
    };
    // Zkontroluje zda není již po splatnosti
    const checkIfPastDue = (dueDate) => {
        const today = new Date(); // Dnešní datum
        const paymentDueDate = new Date(dueDate); // Datum splatnosti
    
        return today > paymentDueDate; // Porovnání dnešního data s datem splatnosti
      };

    // Pošle upomínku
    const SendReaminderToServer = (invoiceToken) => {
        setLoading(true)
        fetchData(server + "api2/adminInvoiceController.php", {
            token: token, 
            invoiceToken: invoiceToken,
            action: "SEND_REMINDER",

    
        }).then((res)=> {
            setLoading(false)
            if(res.status !== "OK"){
                alert('Chyba spojení, zkuste to prosím později.')
            } 
            alert('Upomínka byla poslána')
        })
    }


    return (
        <>
        <Modal
            size="xl"
            show={onShow}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                   Historie faktur
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {loading && 
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <Spinner animation="border" role="status">
                        </Spinner>
                    </div>
                }
                <Alert variant="success" style={{marginTop: 10}}>
                    <Row>
                        <Col>
                            <strong>Číslo</strong>
                        </Col>
                        <Col >
                            <strong>Datum vystavení</strong>
                        </Col>
                        <Col>
                            <strong>Datum splatnosti</strong>
                        </Col>
                        <Col>
                            <strong>Fakturováno na firmu</strong>
                        </Col>
                        <Col>
                            
                        </Col>
       
                    </Row>
                    {
                        listOfInvoices.map( one => {
                            const isPastDue = checkIfPastDue(one.dateTillPay);
                            console.log(one)
                            return  <Row key={one.id}>
                                        <Col>{one.id}</Col>
                                        <Col>{format(one.created_date)}</Col>
                                        <Col style={isPastDue? {color: 'red'} : {}}>{format(one.dateTillPay)}</Col>
                                        <Col>{one.clientName}</Col>
                                        <Col style={{display:'flex', justifyContent: 'flex-end', gap: 10, alignItems: 'center'}}>
                                            {isPastDue && <FontAwesomeIcon icon={faExclamationCircle} color='violet' onClick={()=> SendReaminderToServer(one.token)}/> }
                                            <a href={"https://abcnet.cz:3010/invoice/"+ one.token} target="_blank">
                                                <FontAwesomeIcon icon={faNoteSticky} color='blue' />
                                            </a>
                                            <FontAwesomeIcon icon={faXmark} color='red' onClick={()=> handleDelete(one.id)}/>
                                        </Col>
                                    </Row>
                           
                        })
                    }
                </Alert>
   
            </Modal.Body>
        </Modal>
        </>
    )
}

export default ModalInvoicesHistory
